import { useParams, useNavigate } from "react-router-dom";
import { ExpenseDetailPage as ExpenseDetailPageView } from "@/components/ExpenseDetailPage";
import { useModules } from "@/auth/ModulesContext";
import { BooksDocumentCard } from "@/books/BooksDocumentCard";

export function ExpensePage() {
  const { expenseId } = useParams<{ expenseId: string }>();
  const navigate = useNavigate();
  const { holdsModule } = useModules();

  if (!expenseId) return null;

  return (
    <ExpenseDetailPageView
      expenseId={expenseId}
      onBack={() => navigate("/expenses")}
      onOpenCards={() => navigate("/cards")}
      onOpenCategoryMapping={() => navigate("/expenses/mcc-mappings")}
      onOpenReceipt={(receiptId) => navigate(`/receipts/${receiptId}`)}
      onOpenExpense={(id) => navigate(`/expenses/${id}`)}
      onOpenMerchant={(id) => navigate(`/expenses/merchants/${id}`)}
      onOpenApprovalPolicies={() => navigate("/expenses/approval-policies")}
      booksCard={holdsModule("books") ? <BooksDocumentCard sourceType="Expense" sourceId={expenseId} /> : null}
    />
  );
}
